import { render, staticRenderFns } from "./OutboundShipments.vue?vue&type=template&id=23b3e2da&scoped=true&"
import script from "./OutboundShipments.vue?vue&type=script&lang=js&"
export * from "./OutboundShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3e2da",
  null
  
)

export default component.exports